import React, { useState, useEffect } from "react";
import { FaIndianRupeeSign } from "react-icons/fa6";
import {
  FaClipboardCheck,
  FaStickyNote,
} from "react-icons/fa";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { Container } from "react-bootstrap";
import SportsIMg from "../../assets/img/sports.jpg";
import { getHoliday } from "../../store/slices/holiday";
import { getHomework } from "../../store/slices/homework";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { getNote } from "../../store/slices/notes";
import { getstudentFeesDetails } from "../../store/slices/fees";


export default function StudentHome() {
  const [calendarDate, setCalendarDate] = useState(new Date());
  const dispatch = useDispatch();

  const activeStudent = useSelector(
    (state) => state.activestudent?.student
  );

  const selectedStudentId = activeStudent?._id;
  const activeStandardId = activeStudent?.standardId?._id;
  const activeSectionId = activeStudent?.sectionId?._id;

  const [homeworks, setHomeworks] = useState([]);
  const [notes, setNotes] = useState([]);
  const [fees, setFees] = useState([]);
  const currentSession =
    JSON.parse(localStorage.getItem("currentSession"))?.name ||
    localStorage.getItem("currentSession") ||
    "2026-27";


  useEffect(() => {
    if (!selectedStudentId) return;

    // ================= HOMEWORK =================
    if (activeStandardId && activeSectionId) {
      dispatch(
        getHomework({
          standardId: activeStandardId,
          sectionId: activeSectionId,
        })
      )
        .unwrap()
        .then((res) => {
          setHomeworks(res?.data || []);
        })
        .catch(() => {
          setHomeworks([]);
          toast.error("Failed to load homework");
        });
    }

    // ================= NOTES =================
    if (activeStandardId && activeSectionId) {
      dispatch(
        getNote({
          standardId: activeStandardId,
          sectionId: activeSectionId,
        })
      )
        .unwrap()
        .then((res) => {
          setNotes(res?.data || []);
        })
        .catch(() => {
          setNotes([]);
        });
    }

    // ================= FEES =================
    dispatch(
      getstudentFeesDetails({
        studentId: selectedStudentId,
        session: currentSession,
      })
    )
      .unwrap()
      .then((res) => {
        const feeData = Array.isArray(res?.data) ? res.data : [];
        setFees(feeData);
      })
      .catch(() => {
        setFees([]);
      });
  }, [
    dispatch,
    selectedStudentId,
    activeStandardId,
    activeSectionId,
    currentSession,
  ]);

  const totalFeesPaid = fees.reduce(
    (sum, fee) => sum + Number(fee.totalPaid || 0),
    0
  );

  const totalFeesDue = fees.reduce(
    (sum, fee) => sum + Number(fee.totalDue || 0),
    0
  );
  return (
    <>
      <div className="homepage-container">
        <Container className="dh-container">
          <div className="countdetails-wrapper">
            <div className="countdetails-card">
              <div className="countdetails-icon">
                <FaClipboardCheck />
              </div>
              <div className="countdetails-text">
                <p>Total Homework</p>
                <h3>{homeworks.length}</h3>
              </div>
            </div>

            <div className="countdetails-card">
              <div className="countdetails-icon">
                <FaStickyNote />
              </div>
              <div className="countdetails-text">
                <p>Total Notes</p>
                <h3>{notes.length}</h3>
              </div>
            </div>

            <div className="countdetails-card">
              <div className="countdetails-icon">
                <FaIndianRupeeSign />
              </div>
              <div className="countdetails-text">
                <p>Fees Paid</p>
                <h3>₹{totalFeesPaid?.toLocaleString("en-IN")}</h3>
              </div>
            </div>

            <div className="countdetails-card">
              <div className="countdetails-icon">
                <FaIndianRupeeSign />
              </div>
              <div className="countdetails-text">
                <p>Fees Due</p>
                <h3>₹{totalFeesDue?.toLocaleString("en-IN")}</h3>
              </div>
            </div>
          </div>


          <div className="dh-bottom mt-5">
            <div className="nb-card">
              <div className="nb-header mb-3">
                <h4 >Homework</h4>

              </div>
              <div className="nb-list">
                {homeworks.length > 0 ? (
                  homeworks.slice(0, 5).map((item) => (
                    <div className="nb-item mb-2" key={item._id}>
                      <div
                        className="nb-thumb"
                        style={{
                          width: 45,
                          height: 45,
                          borderRadius: "50%",
                          background: "#8451ff",
                          color: "#fff",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: 600,
                          fontSize: 18,
                        }}
                      >
                        {item.subjectId?.name?.charAt(0)}
                      </div>

                      <div className="nb-content">
                        <p className="nb-title">{item.subjectId?.name}</p>

                        <small style={{ color: "#6b7280" }}>
                          {item.description?.length > 60
                            ? item.description.substring(0, 60) + "..."
                            : item.description}
                        </small>
                      </div>

                      <div className="nb-daterow">
                        <span className="nb-date">
                          {new Date(item.dueDate).toLocaleDateString("en-IN", {
                            day: "2-digit",
                            month: "short",
                          })}
                        </span>
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="text-center text-muted py-3">
                    No homework available
                  </p>
                )}
              </div>
            </div>
            {/* Event Calendar */}
            <div className="dh-card dh-calendar-card">
              <div className="dh-calendar-head">
                <h4>Event Calendar</h4>

              </div>

              <Calendar
                onChange={setCalendarDate}
                value={calendarDate}
                showNeighboringMonth={false}
                next2Label={null}
                prev2Label={null}
                formatShortWeekday={(locale, date) =>
                  date.toLocaleDateString(locale, { weekday: "short" })
                }
              />
            </div>
          </div>
        </Container>
      </div>
    </>
  );
}

/* ---------------> SMALL COMPONENTS  <--------------- */

const AttendanceTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="dh-att-tooltip">
        <p className="dh-att-day">{label}</p>
        <p className="present">
          ● Present: {payload.find((p) => p.dataKey === "present")?.value}
        </p>
        <p className="absent">
          ● Absent: {payload.find((p) => p.dataKey === "absent")?.value}
        </p>
      </div>
    );
  }
  return null;
};